// 用例列表相关类型定义

import { t } from '@/i18n'
import lowImg from '@/assets/imges/leak-low.png'
import centerkImg from '@/assets/imges/leak-center.png'
import highImg from '@/assets/imges/leak-high.png'
import severityImg from '@/assets/imges/leak-severity.png'

export interface UseCaseItem {
  resourceId: string
  name: string
  riskLevel: 'RiskLevelHigh' | 'RiskLevelGross' | 'RiskLevelMiddle' | 'RiskLevelLow'
  resourceLevel: 'ResourceLevelSenior' | 'ResourceLevelMiddle' | 'ResourceLevelJunior'
  attackTypeId: string
  updateTime: string
  templateIds: string[] // 关联的模板ID数组
}

export interface UseCaseSearchParams {
  page: number
  pageSize: number
  queryType: string
  os: string
  templateId: string[]
  filterParams: {
    name?: string
    riskLevel?: string
    resourceLevel?: string
    attackTypeId?: string
    tagId?: string
    sceneId?: number[]
    verificationModeId?: number[]
  }
}

export interface UseCaseResponse {
  list: UseCaseItem[]
  total: number
}

// 风险等级选项
export const RISK_LEVELS = [
  { value: 'RiskLevelHigh', label: t('高危'), color: '#FF4141', bg: '#FFE1E1', icon: highImg },
  { value: 'RiskLevelGross', label: t('严重'), color: '#B70000', bg: '#F5D9D9', icon: severityImg },
  { value: 'RiskLevelMiddle', label: t('中危'), color: '#FFA709', bg: '#FFEDCE', icon: centerkImg },
  { value: 'RiskLevelLow', label: t('低危'), color: '#6F9FFF', bg: '#E1EBFE', icon: lowImg },
] as const

// 用例分级选项
export const RESOURCE_LEVELS = [
  { value: 'ResourceLevelSenior', label: t('高级'), color: '#fff', bg: '#F44F4F' },
  { value: 'ResourceLevelMiddle', label: t('中级'), color: '#fff', bg: '#FFA709' },
  { value: 'ResourceLevelJunior', label: t('初级'), color: '#fff', bg: '#6F9FFF' },
] as const
